<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2R7fBZ/tc-custom/9781507300985.jpg?1731796627811" alt="This image is the cover for the book Angry Little Puffin"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Angry Little Puffin
      </h1>
      <p class="bookDescription body article font2">
        <p>This story about a puffin who is upset that he's constantly mistaken for a penguin teaches that, when feeling alone, angry, or misunderstood, it takes only one person to turn things around.  “Look at the funny little penguin!” and “What a silly-looking penguin!” Hearing this all day long is enough to make any little bird angry, especially when he’s NOT A PENGUIN! This is the story of a puffin who is upset that he’s constantly mistaken for a penguin. He finally reaches his breaking point and goes on a rant about the many differences between the two. A little girl stops him in mid-speech because she does know the differences, and he listens as she explains to her father why puffins are her favorite.  When you are feeling alone and misunderstood, sometimes it only takes the understanding of one small person to turn things around. A charming picture book with 18 fun colorful spreads. This book shows children what frustration and feeling alone looks like from the outside, how to get over anger, and how to reach out to others when they are frustrated.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Timothy Young
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Schiffer Publishing, Ltd.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?126bce5b